module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1052-b6f15e0045b17a36332532fc81353943.png";